import styled from "styled-components";
import { Paper } from "@mui/material";

export const MegaMenuPaper = styled(Paper)`
  padding: 32px 24px;
  width: 100%;
  margin: 0 auto;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  background: #fff;
`;

export const MenuColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  height: 100%;

  @media (max-width: 768px) {
    padding: 12px 8px;
  }
`;

export const MenuTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: #0a5079;
  text-transform: uppercase;
  margin: 0 0 8px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid #2786bd;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MenuItemsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MenuItemLink = styled.li`
  font-size: 14px;
  font-weight: 500;
  color: #2786bd;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  &:hover {
    background-color: #eef8ff;
    color: #0a5079;
    transform: translateX(4px);
  }

  span {
    flex: 1;
  }

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    opacity: 0.7;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #666;
  font-size: 14px;
`;
